import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import TransferOrderTable from './components/TransferOrderTable/TransferOrderTable';
import { getOrders, setShowModal, clearOrder, clearOrderItems } from './TransferOrderActions';
import { AppState } from '../../reducers';
import Filter from '../components/Filter/Filter';
import { Button } from 'antd';
import Modal from './components/Modal/Modal';
import { I18n } from 'react-redux-i18n';
import cloneDeep from 'lodash.clonedeep';
import findIndex from 'lodash.findindex';

class TransferOrderList extends React.Component<any, any> {

  componentDidMount() {
    const retrievedObject: any = localStorage.getItem('default_values') || '{}';
    const limit: number = JSON.parse(retrievedObject).t_o_limit;
    const filter: any = cloneDeep(this.props.filter);
    const indexLimit = findIndex(this.props.filter, ['attribute', 'limit']);

    if (indexLimit > -1) {
      filter[indexLimit].value = limit || 10;
    } else {
      filter.push({ attribute: 'limit', value: 10 });
    }

    const indexSkip = findIndex(this.props.filter, ['attribute', 'skip']);
    if (indexSkip > -1) {
      filter[indexSkip].value = 0;
    }

    this.props.getOrders(filter);
  }

  onChangeFilter = (filter: any) => {
    this.props.getOrders(filter);
  }

  public render() {
    const {filter, storages, types, is_mobile} = this.props;
    return (
      <div>
        <Modal
          title= {I18n.t('transfer_order.Transfer Order Title')}
        />
        <Filter
          onChange={this.onChangeFilter}
          initialValues={filter}
          attributes={[
            {
              name: 'date',
              title: I18n.t('transfer_order.Date'),
              hyper_type: 'date',
              comparison: 'date_is_within',
            },
            // {name: 'order_name', title: 'Name ddf', hyper_type: 'input', comparison: 'contains'},
            { name: 'storage_from_id',
              title: I18n.t('transfer_order.Storage From'),
              hyper_type: 'select',
              options: storages.map((item: any) => {
                return {
                  title: item.name,
                  value: item.id,
                };
              }),
            },
            { name: 'storage_to_id',
              title: I18n.t('transfer_order.Storage To'),
              hyper_type: 'select',
              options: storages.map((item: any) => {
                return {
                  title: item.name,
                  value: item.id,
                };
              }),
            },
            {
              name: 'doc_type',
              title: I18n.t('sales_order.Type'),
              hyper_type: 'select',
              options: types.map((item: any) => {
                  return {
                    title: item.short_title,
                    value: item.id,
                  };
              }),
            },
          ]}
        />
        <Button 
          style={{
            margin: '16px 0',
          }}
          onClick={() => {
            this.props.clearOrder();
            this.props.clearOrderItems();
            this.props.setShowModal(true);

          }}
        >
          {I18n.t('transfer_order.Create')}
        </Button>

        <TransferOrderTable />

      </div>
    );
  }
}

const mapStateToProps = (state: AppState) => ({
  filter: state.transfer_order.filter,
  is_mobile: state.auth.is_mobile,
  storages: state.started_data.storages,
  // TODO
  types: state.started_data.dictionaries.filter((item: any) => item.d_type === 'transfer_order'),
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      getOrders,
      setShowModal,
      clearOrder,
      clearOrderItems,
    },
    dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(TransferOrderList);
